import InvoicesBulkUpdateModal from './InvoicesBulkUpdateModal';

export default InvoicesBulkUpdateModal;
